export const EN_LOCALES = {
  ACCEPT_COOKIES: 'Accept cookies',
  ADDED: 'Added',
  ADD_ITEM: 'Add Item',
  ADD_SERVICES_TO_ORDER: 'add services to the order',
  ADD_TO_ORDER: 'Add to Order',
  AFTERCARE_SERVICES: 'Grave Care Services',
  ASK_YOUR_QUESTION: 'Ask your question and we will contact you as\u00a0soon\u00a0as\u00a0possible',
  BACK: 'Back',
  BACK_TO_HOME_PAGE: 'Back to home page',
  BACK_TO_MAIN_PAGE: 'Back to the main page',
  BACK_TO_RECORD_PAGE: 'Back to record page',
  BLOCK: 'Block',
  CANCEL: 'Cancel',
  CART_EMPTY: 'Cart is empty',
  CEMETERY: 'Cemetery',
  CHECKOUT: 'Checkout',
  CHECK_ORDER_DETAILS: 'Check the order details and provide purchaser information.',
  CLOSE_CART: 'Close cart',
  CLOSE_GALLERY: 'Close Gallery',
  CONTACT_CEMETERY: 'Contact Cemetery',
  COPIED: 'Copied',
  COPY_URL: 'Copy URL',
  DECEDENT: 'Decedent',
  DISMISS: 'Dismiss',
  DOWNLOAD_FREE_MOBILE_APP: 'Download free mobile app',
  EACH: 'each',
  EMAIL: 'Email',
  EMAIL_FORMAT: 'Invalid email format (user@example.com)',
  ENTER_CARD_INFO: 'Enter credit or debit card information',
  FACEBOOK: 'Facebook',
  FIND_LOCATION: 'Find Location',
  FIRST_NAME: 'First Name',
  FIRST_NAME_MIN_LENGTH: 'First Name is too short (2 characters min)',
  GO_TO_PAYMENT: 'Go to payment',
  GO_TO_X_PAGE: 'Go to {X} page',
  IF_YOU_HAVE_QUESTION:
    "If you have questions about services, or if the service you need is not listed, contact with us and we'll try to help you.",
  INDEX_PAGE: 'Index',
  LAST_NAME: 'Last Name',
  LAST_NAME_MIN_LENGTH: 'Last Name is too short (2 characters min)',
  LOCATION: 'Location',
  LOGO: 'logo',
  MAKE_PAYMENT: 'Make a payment',
  MESSAGE_MIN_LENGTH: 'Message is too short (5 characters min)',
  MOVE: 'Move',
  NAME_MIN_LENGTH: 'Name is too short (2 characters min)',
  NEXT: 'Next',
  NO: 'No',
  ON_OUR_WEBSITE_WE_USE_COOKIE:
    'On our website we use technical, analytical, marketing and preference cookies. These are necessary for our site to work properly and to give us information about how our site is used.',
  OPEN_CART: 'Open cart',
  ORDER_CREATED: 'Order Created',
  ORDER_DETAILS_WILL_BE_SENT: 'Order details will be sent to provided email address',
  ORDER_NUMBER: 'Order Number',
  ORDER_TOTAL: 'Order Total',
  PAGE_LINK_HAS_BEEN_COPIED: 'Page link has been copied to the clipboard',
  PAYMENT: 'Payment',
  PAYMENT_ERROR: 'Payment error',
  PAYMENT_FORM_EXPIRED: 'Payment form expired',
  PER: 'per',
  PHONE_FORMAT: 'Invalid phone format',
  PHONE_NUMBER: 'Phone Number',
  PHOTO: 'Photo',
  PLACE_ORDER: 'Place order',
  PLACEMENT: 'placement',
  PLEASE_TRY_AGAIN_LATER: 'Please try again later',
  PLOT: 'Plot',
  PREVIOUS: 'Previous',
  PRIVACY_POLICY: 'Privacy Policy',
  PURCHASER: 'Purchaser',
  RECEIVE_REPORT_BY_EMAIL:
    'You will receive a notification of the completion of work and a photo report by email',
  REJECT: 'Reject',
  RELOAD_PAGE: 'Reload page',
  REMOVE_FROM_CART: 'Remove from Cart?',
  REMOVE_ITEM: 'Remove Item',
  RESTORATION_TOMBSTONE: 'Restoration tombstone',
  REQUIRED_DATA: 'Required data',
  REQUIRED_FIELDS_MISSING: 'Some required fields are missing',
  SEARCH: 'Search',
  SEARCH_BURIAL_RECORDS: 'Search Burial Records',
  SECTION: 'Section',
  SEE_EXAMPLES: 'See examples',
  SERVICES: 'Services',
  SHARE: 'Share',
  SHARE_ORDER: 'Share order',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  SPECIAL_INSTRUCTIONS: 'Special Instructions',
  STEP_OF_3: 'Step {X} of 3',
  SUBMIT: 'Submit',
  TERMS_AGREED_LINK: 'Privacy Policy and Terms of Use',
  TERMS_AGREED_TEXT: 'I agree to the',
  THIS_WEBSITE_USES_COOKIES: 'This website uses cookies',
  THANK_YOU: 'Thank You!',
  THE_YEAR_OF_DEATH_LATER: 'DoD must be later than DoB',
  TOTAL: 'total',
  TOTAL_AMOUNT_INCORRECT: 'Services total amount is incorrect',
  UNKNOWN: 'unknown',
  WE_WILL_CONTACT_YOU_SHORTLY: 'We will contact you shortly!',
  WEBSITE: 'Website',
  YEAR: 'year',
  YEAR_LATER: 'Years of life cannot be in the future',
  YEAR_OF_BIRTH: 'Year of Birth',
  YEAR_OF_DEATH: 'Year of Death',
  YEARS_OF_LIFE: 'Years of Life',
  YES: 'Yes',
  YOUR_MESSAGE: 'Your Message',
  YOUR_NAME: 'Your Name',
};
